import { browserProfilingIntegration, browserTracingIntegration, init, replayIntegration, type BrowserOptions } from '@sentry/react';
import { type History } from 'history';
import { development, platform, sentryDsn, version } from './config';
import { logger } from './log';

export function initSentry({ history }: { history: History }) {
  const log = logger('sentry');

  if (sentryDsn) {
    const options: BrowserOptions = {
      dsn: sentryDsn,
      release: `rescuetablet@${version}`,
      environment: platform,
      enabled: !development,
      tracePropagationTargets: ['localhost', 'missions-api.rescuetablet.com'],
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1,
      profilesSampleRate: 0.1,
    };

    log.info(`Initializing Sentry: ${JSON.stringify(options)}`);

    init({
      ...options,
      integrations: [browserProfilingIntegration(), browserTracingIntegration(), replayIntegration()],
    });
  } else {
    log.info('Sentry is disabled');
  }
}
